export default __webpack_public_path__ + "static/media/SAS Alert Tone 4.1e9f2693.wav";